/* eslint-disable max-len */
import styled from 'styled-components';
import { ThumbnailContainer } from '@gcc/pip-components/dist/Visualizer/styles';
import { Accordion, AccordionTitle, AccordionBody } from '@thd-olt-component-react/core-ui';

export const StyledConsumerCardMessagingDiv = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;

  /* Consumer card messaging: reorder elements to display info icon after "Apply Now" link */
  .sui-inline-flex.sui-items-center > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }

  /* Move info icon to end using flexbox order */
  .sui-inline-flex.sui-items-center > div > .sui-pr-1.sui-cursor-pointer.sui-relative.sui-down-1 {
    order: 3;
    padding-left: 4px;
    height: 16px;
  }

  /* Position "Apply Now" link before icon */
  .sui-inline-flex.sui-items-center > div > span:has(#credit-promo-apply-now) {
    order: 2;
  }

  .everyday-financing-message {
    display: block;
  }
  .everyday-financing-apply-now-link {
    margin-left: 5px;
  }
  #credit-promo-apply-now {
    color: rgb(var(--sui-palette-text-primary) / var(--tw-text-opacity, 1));
  }
`;

/* export const CompareSurfaceStyle = styled.div`
  color: black;
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 10px;
  :hover {
    text-decoration-color: #f96303;
  }
`; */
export const CompareSurfaceStyle = styled.div``;

export const StyledAccordionBody = styled(AccordionBody)`
  border-top: 1px solid #ccc;
`;

/* export const AccordionContainer = styled.div`
  background-color: white;
  padding: 20px;

  @media (min-width: 820px) {
    max-width: 530px;
  }
  min-width: 100%;
`; */

export const AccordionContainer = styled.div``;

export const StyledAccordionTitle = styled(AccordionTitle)`
  font-weight: 900;
  img {
    filter: brightness(0) saturate(100%);
    stroke-width: 0.1;
  }
`;

/* export const AccoridionHeader = styled.div`
  font-weight: 900;
  margin-bottom: 10px;
  font-size: 15px;
`; */

export const HowAccoridionHeader = styled.div``;

export const AccordionRow = styled(Accordion)`
  border: 1px solid #ccc;
  margin-bottom: 17.5px;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin: auto;
  max-width: 1440px;
  box-sizing: border-box;
`;

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-width: 1440px;
  padding: 0 7px;
  flex: 1 1 auto;
  max-width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: stretch;
  max-width: 100%;
`;

export const Column = styled.div`
  @media (max-width: 575px) {
    padding: 0 10px;
  }
`;

export const VisualizerSummaryContainer = styled.div`
  @media (min-width: 992px) {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    align-content: space-between;
    min-height: 385px;
  }
`;

export const VisualizerWrapper = styled.div`
  flex: 1 1 55%;
  height: 815px;
  max-width: 890px;
  @media (max-width: 575px) {
    height: auto;
  }
  @media (min-width: 1025px) {
    flex: 1 1 58.333%;
  }
  & > div {
    padding: 0 0px;
  }
`;

export const SummaryWrapper = styled.div`
  flex: 1 1 45%;
  @media (min-width: 1025px) {
    flex: 1 1 41.666%;
    max-width: 41.666%;
  }
  & > div {
    display: flex;
    flex-direction: column;
    align-content: space-evenly;
    justify-content: space-between;
  }
`;

export const ProductOverviewImages = styled.div`
  ${ThumbnailContainer} {
    > img {
      object-fit: cover;
    }
  }
`;
/* export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 530px;
  // flex-wrap: wrap;
  justify-content: flex-start;
  // min-height: 815px;
  @media (max-width: 991px) {
    height: auto;
    min-width: auto;
  }
`; */

export const Summary = styled.div``;

/* export const ProductSummaryContainer = styled.div`
  padding: 20px;
`; */

export const ProductSummaryContainer = styled.div``;

export const Mobile = styled.div`
  display: none;
  @media (max-width: 575px) {
    display: block;
  }
`;

export const NotMobile = styled.div`
  display: none;
  @media (min-width: 576px) {
    display: block;
  }
`;

export const Footnote = styled.div`
  padding: 10px 0;
`;

export const PlaPriceWrapper = styled.div`
  .sui-text-primary {
    font-size: 4.4rem;
  }
`;

export const PriceDivWrapper = styled.div`
  background: white;
  display: flex;
  margin: 0 0 1rem 0;

  .product-price-special-buy {
    padding: 1.5rem 0 0 1rem;
  }
`;

export const InfoWrapper = styled.div`
  background: white;
  display: block;
  padding: 1rem 0 0.5rem 1rem;
  margin: 0 0 1rem 0;
`;

export const PlaPricePlaceholder = styled.div`
  background: #ffffff;
  height: 12.2rem;
  margin: 0 0 1rem 0;
`;

export const ProductDetailsPlaceholder = styled.div`
  min-height: 12rem;
`;
